module.exports = "/static-assets/_next/static/images/your-new-favorite-thing-782c53ecdf4b6c57910ee161146a3ae0.svg";